import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { NoticeTypeService, NoticeType, TemplateTypeService } from "../../../../swaggerServices";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { UntypedFormBuilder, Validators, UntypedFormGroup, AbstractControl } from "@angular/forms";

@Component({
    selector: 'app-update-notice-type',
    templateUrl: './update-notice-type.component.html',
    styleUrls: ['./update-notice-type.component.scss'],
    standalone: false
})
export class UpdateNoticeTypeComponent implements OnInit, OnDestroy {

  noticeType: NoticeType;
  templateTypeList = [];
  noticeTypeGroupList = [
    {value: 'AS', label: 'PAYGs'},
    {value: 'EX', label: 'Exception'},
    {value: 'NOA', label: 'NOAs'},
    {value: 'ST', label: 'Save to Docshare'},
    {value: 'GE', label: 'Straight through'}
  ];

  form: UntypedFormGroup;
  isCreate: boolean = false;
  private unsubscribe = new Subject<void>();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private noticeTypeService: NoticeTypeService,
    private templateTypeService: TemplateTypeService,
    private dialogRef: MatDialogRef<UpdateNoticeTypeComponent>,
    @Inject(MAT_DIALOG_DATA) noticeType: NoticeType
  ) {
    this.noticeType = noticeType;
  }

  get noticeTypeName(): AbstractControl {
    return this.form.get('noticeTypeName');
  }

  get noticeTypeDisplayName(): AbstractControl {
    return this.form.get('noticeTypeDisplayName');
  }

  get noticeTypeGroup(): AbstractControl {
    return this.form.get('noticeTypeGroup');
  }

  get templateType(): AbstractControl {
    return this.form.get('templateType');
  }

  ngOnInit() {
    this.isCreate = !this.noticeType;
    this.initForm();
    this.setTemplateTypeList();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  saveNoticeType() {
    const postData = {
      name: this.noticeTypeName.value,
      displayName: this.noticeTypeDisplayName.value,
      group: this.noticeTypeGroup.value,
      templateTypeId: parseInt(this.templateType.value, 10)
    };
    if (this.isCreate) {
      postData['source'] = 'Manual';
      this.noticeTypeService.addNoticeType(postData).subscribe(result => {
        this.dialogRef.close(true);
      }, error => {
        this.dialogRef.close(false);
      });
    } else {
      this.noticeTypeService.updateNoticeType(this.noticeType.id, postData).subscribe(result => {
        this.dialogRef.close(true);
      }, error => {
        this.dialogRef.close(false);
      });
    }

  }

  onClose() {
    this.dialogRef.close(false);
  }

  formatter(option) {
    return option.label;
  }

  private initForm() {
    this.form = this.formBuilder.group({
      noticeTypeName: ['', Validators.required],
      noticeTypeDisplayName: [''],
      noticeTypeGroup: ['', Validators.required],
      templateType: ['']
    });

    if (!this.isCreate) {
      this.noticeTypeName.setValue(this.noticeType.name);
      this.noticeTypeDisplayName.setValue(this.noticeType.displayName);
      this.noticeTypeGroup.setValue(this.noticeType.group);
      this.templateType.setValue(this.noticeType.templateTypeId);
    }


  }

  private setTemplateTypeList() {
    this.templateTypeService.getTemplateTypes()
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(result => {
      const templateTypes = [{ value: null, label: 'No template'}];
      if (result && result.length>0) {
        result.forEach(templateType =>  {
          if(templateType.module === 'NOTICE') {
            templateTypes.push({ value: templateType.id, label: templateType.templateType });
          }
        });
      }
      this.templateTypeList = templateTypes;
    });
  }

}
